export enum AsistenteTipo {
    Chat = "Chat",
    Formulario = "Formulario",
    Menu = "Menu"
}